// extracted by mini-css-extract-plugin
module.exports = {"card":"CareerCard_card__1VNH5","title":"CareerCard_title__2R-GV","description":"CareerCard_description__1sb0Y","apply":"CareerCard_apply__3T62g"};